import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useSelector, useDispatch } from 'react-redux';
import { Routes, Route, useNavigate } from 'react-router-dom';
import SAT_DELIVERY_PORTAL_IMG from '../../../src/assets/images/sat-delivery-portal-bg.png';
import SAT_DELIVERY_PORTAL_ARROW from '../../../src/assets/images/arrow-tr.svg';
import AppContainer from '../appContainer/AppContainer';
import Header from '../common/header/Header';
import Banner from '../common/banner/Banner';
import SearchContainer from '../searchContainer/SearchContainer';
import BottomBanner from '../common/bottomBanner/BottomBanner';
import Sidebar from '../sideBarComponent/SidebarComponent';
import { IStore } from '../../store';
import RightSidebar from '../sideBarComponent/RightSidebar';
import {
  setByodDocOpenClose,
  setRightSideBarOpenClose,
  showMyJuniorModal
} from '../../store/actions/commonActions';
import useWindowSize from '../../utils/CommonHooks/useWindowSize';
import UploadDataTiles from '../uploadDataContainer/UploadDataTiles';
import NewChatPage from '../newChatPage/NewChatPage';
import { closeIcon, sideBarExpanded, sidebarExpendedOpen } from '../../commonImage';
import { AddDocument } from '../uploadDocumentsContainer/AddDocument';
import ExploretData from '../ExploreData/ExploreData';
import PublicChatTile from '../publicChatContainer/PublicChatTile';
import SurveyInsights from '../surveyInsights/SurveyInsights';
import SectorInsights from '../sectorInsights/SectorInsights';
import Transcripts from '../transcripts/Transcripts';
import SectorChatPage from '../SectorChatPage/SectorChatPage';
import SurveySidebar from '../sideBarComponent/SurveySideBarComponent';
import LoadingIndicator from '../openAIChat/LoadingIndicator';
import PolicyStepper from '../common/policy/PolicyStepper';
import { setIsSurveyDocList } from '../../store/actions/userChatActions';
import { getXMonthsDate } from '../../utils/commonUtils';
import { getSurveysListResponse } from '../../services/chatQuery.service';
import ExpertChatPage from '../EyExperts/ExpertChatPage';
import { SAT_PORTAL_ROUTE } from '../../app.constant';
import EyIpKcChatPage from '../EyIpKcContainer/EyIpKcChatPage';
import MarketReportsHome from '../MarketReportsHome/MarketReportsHome';
import MyJuniorModal from '../common/myjuniorModal/MyJuniorModal';
import CombinedMarketReports from '../CombinedMarketReports/CombinedMarketReports';
import DeepResearch from '../deepResearch/DeepResearch';
// import UploadURLTile from '../uploadURLContainer/UploadURLTile';

type UserApp = {
  isFavourite: boolean;
  name: string;
  url?: string;
  imageName?: string;
};
type UserApps = UserApp[];
export interface IAppStoreProps {
  userApps: UserApps;
  dataSources?: string[];
  isLoading?: boolean;
}

const AppStoreComponent = ({ userApps, dataSources, isLoading }: IAppStoreProps): JSX.Element => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [windowSize] = useWindowSize();
  const showPrivacyAndTermsModal = useSelector(
    (store: IStore) => store.common.showPrivacyAndTermsModal
  );
  let transformedUserApps: UserApps = [];
  if (userApps?.length > 0) {
    transformedUserApps = userApps
      .join('|')
      .toLowerCase()
      .split('|')
      .map((name) => ({
        isFavourite: false,
        name
      }));
  }
  const [homeInputValue, setHomeInputValue] = useState('');
  const isRightSideBarOpen = useSelector((state: IStore) => state.common.isRightSideBarOpen);
  const isSurveyDocOpen = useSelector((state: IStore) => state.common.isSurveyDocOpen);
  const isByodDocOpen = useSelector((state: IStore) => state.common.isByodDocOpen);
  const pathName = window.location.pathname;
  const isSidebarOpen = useSelector((state: IStore) => state.common.isSideBarOpen);
  const isShowMyJuniorModal =
    useSelector((state: IStore) => state.common?.showMyJuniorModal) || false;

  window.onload = function () {
    delete localStorage.isSidebarManuallyClosed;
  };

  const toggleRightSideBar = (event: any) => {
    if (event?.type === 'click' && isRightSideBarOpen === true) {
      localStorage.isSidebarManuallyClosed = true;
    }
    dispatch(setRightSideBarOpenClose(!isRightSideBarOpen));
  };

  const handleInputData = (data: string) => {
    setHomeInputValue(data);
  };

  const handleSectorApi = async () => {
    const queryBody = JSON.stringify({
      fromdate: ''
    });
    const controller = new AbortController();
    try {
      const response = await getSurveysListResponse(queryBody);
      const result = response ? await (response as Response).json() : null;
      if (result && result?.sectors) {
        dispatch(setIsSurveyDocList(result));
      }
    } catch (error) {
      if (controller.signal.aborted) {
        console.warn('::APi call failed', error);
      }
    }
  };

  useEffect(() => {
    handleSectorApi();
    localStorage.removeItem('surveycustomperiod');
    localStorage.removeItem('surveyDateSelectedOption');
    localStorage.removeItem('selectedSurveyList');
    localStorage.removeItem('selectedDropSectors');
    localStorage.removeItem('surveytoDate');
    localStorage.removeItem('surveycustomperiod');
    localStorage.removeItem('queryFromDate');
    localStorage.removeItem('queryToDate');
  }, []);

  const routeToSaTDeliveryPortal = () => {
    window.open(SAT_PORTAL_ROUTE, '_blank');
  };

  const renderSaTDeliveryPortal = () => {
    return (
      <div className='sat-delivery-div' onClick={() => routeToSaTDeliveryPortal()}>
        <div className='image-container'>
          <img src={SAT_DELIVERY_PORTAL_IMG} alt='SaT Delivery Portal image' />
          {/* <div className='text-div'>
            <span className='info'>Strategy and Transactions Delivery Portal</span>
            <br className='teams-app-break-div'></br>
            <span className='info-1'>Transform the way we work through technology</span>
          </div>
          <div className='button-div'>
            <button className='btn secondary-btn launch-btn' onClick={routeToSaTDeliveryPortal}>Launch SAT Delivery Portal  <img className='btn-arrow' src={SAT_DELIVERY_PORTAL_ARROW}></img></button>
          </div> */}
        </div>
      </div>
    );
  };

  const handleShowMyJuniorModal = (value: boolean) => {
    dispatch(showMyJuniorModal(value));
  };

  const isDataSourcesLoaded = dataSources && Object.keys(dataSources).length > 0;
  const hasExpertChatAccess =
    isDataSourcesLoaded && Object.keys(dataSources).includes('findEyExpert');

  const ExpertChatRedirect = ({
    isDataSourcesLoaded,
    hasExpertChatAccess
  }: {
    isDataSourcesLoaded: boolean;
    hasExpertChatAccess: boolean;
  }) => {
    const navigate = useNavigate();
    useEffect(() => {
      if (isDataSourcesLoaded && !hasExpertChatAccess) {
        navigate('/');
      }
    }, [isDataSourcesLoaded, hasExpertChatAccess, navigate]);
    return null;
  };

  return (
    //@ts-ignore
    <StyleAppStoreComponent
      isRightSideBarOpen={isRightSideBarOpen}
      isSidebarOpen={isSidebarOpen}
      pathName={pathName}
      isLoadingAPI={isLoading}
      isSurveyDocOpen={isSurveyDocOpen}
      isByodDocOpen={isByodDocOpen}>
      <Header />

      <div className='bg-img-div'>
        <RightSidebar isOpen={isRightSideBarOpen} userApps={userApps} />
        {!isSurveyDocOpen && pathName !== '/deepResearch' && (
          <Sidebar isOpen={isSidebarOpen} dataSources={dataSources} isLoading={isLoading} />
        )}
        {isSurveyDocOpen && <SurveySidebar isOpen={isSurveyDocOpen} />}

        <div
          className={`main-content ${isSurveyDocOpen ? 'sidebar-with-survey' : 'sidebar-closed'} ${pathName === '/surveyChatPage' ? 'surveychatpage' : ''}`}>
          {/* <button onClick={toggleRightSideBar} className='toggleRightSideBar'>
          <img src ={isRightSideBarOpen ? sideBarOpenIcon:sideBarCloseIcon}></img>
          </button> */}
          {!isRightSideBarOpen ? (
            <img
              src={sideBarExpanded}
              onClick={(e) => toggleRightSideBar(e)}
              className='toggleRightSideBar toggle-open'></img>
          ) : (
            <img
              src={sidebarExpendedOpen}
              onClick={(e) => toggleRightSideBar(e)}
              className='toggleRightSideBar toggle-close'></img>
          )}
          <Routes>
            <Route
              path='/publicChatPage'
              element={
                <>
                  <PublicChatTile chatQueryApi={homeInputValue} />
                </>
              }
            />
            <Route
              path='/marketReports'
              element={
                <>
                  <MarketReportsHome />
                </>
              }
            />
            <Route
              path='/with-marketReports'
              element={
                <>
                  <CombinedMarketReports chatQueryApi={homeInputValue} />
                </>
              }
            />
            <Route
              path='/sectorChatPage'
              element={
                <>
                  <SectorChatPage />
                </>
              }
            />
            <Route
              path='/kcChatPage'
              element={
                <>
                  <EyIpKcChatPage sectors={[]} geographies={[]} contentage={''} />
                </>
              }
            />
            <Route
              path='/sectorChatPage'
              element={
                <>
                  <SectorInsights sectors={[]} geographies={[]} contentage={''} />
                </>
              }
            />
            <Route
              path='/surveyChatPage'
              element={
                <>
                  <SurveyInsights />
                </>
              }
            />
            <Route
              path='/transScriptChatPage'
              element={
                <>
                  <Transcripts />
                </>
              }
            />
            <Route
              path='/uploadPage'
              element={
                <>
                  <AddDocument />
                </>
              }
            />
            {/* <Route
              path='/uploadURLPage'
              element={
                <>
                  <UploadURLTile chatQueryApi={homeInputValue} />
                </>
              }
            /> */}
            <Route
              path='/exploreData'
              element={
                <>
                  <ExploretData />
                </>
              }
            />
            <Route
              path='/newChat'
              element={
                <>
                  <NewChatPage />
                </>
              }
            />

            <Route
              path='/expertChatPage'
              element={
                isDataSourcesLoaded && hasExpertChatAccess ? (
                  <ExpertChatPage />
                ) : (
                  (() => {
                    return (
                      <ExpertChatRedirect
                        isDataSourcesLoaded={!!isDataSourcesLoaded}
                        hasExpertChatAccess={!!hasExpertChatAccess}
                      />
                    );
                  })()
                )
              }
            />

            <Route
              path='/'
              element={
                <>
                  <Banner />
                  <SearchContainer getInputData={handleInputData} />
                  <BottomBanner />
                  {!isLoading ? (
                    <div>
                      <div className='scrollable'>
                        <AppContainer userApps={userApps} isLoading={isLoading} />
                        <div className='app-store-div footer-bg-img'></div>
                      </div>
                      {renderSaTDeliveryPortal()}
                    </div>
                  ) : (
                    <div className='loadingClass'>
                      <LoadingIndicator />
                    </div>
                  )}
                </>
              }
            />
            <Route
              path='/deepResearch'
              element={
                <>
                  <DeepResearch />
                </>
              }
            />
          </Routes>
          <MyJuniorModal
            headerIcon={
              <img
                onClick={() => {
                  handleShowMyJuniorModal(false);
                }}
                className='se-close'
                src={closeIcon}
                alt='close-icon'
              />
            }
            show={isShowMyJuniorModal}
            onClose={() => {
              handleShowMyJuniorModal(false);
            }}
          />
        </div>
      </div>
    </StyleAppStoreComponent>
  );
};

const StyleAppStoreComponent = styled.div<{
  isSidebarOpen?: boolean;
  isRightSideBarOpen?: boolean;
  width: string;
  pathName: string;
  isLoadingAPI?: boolean;
  isSurveyDocOpen?: boolean;
  isByodDocOpen?: boolean;
}>`
  background: #fff;
  .bg-img-div {
    height: 100%;
    min-height: 180vh;
    background: rgb(255, 255, 255);
    margin: 0px;
    ::-webkit-scrollbar {
      display: none;
    }
    width: ${(props) =>
      (props.isSidebarOpen && props.isRightSideBarOpen) ||
      (props.isSurveyDocOpen && props.isRightSideBarOpen) ||
      (props.isByodDocOpen && props.isRightSideBarOpen)
        ? 'calc(100% - 480px)'
        : !props.isByodDocOpen &&
            !props.isSidebarOpen &&
            !props.isSurveyDocOpen &&
            !props.isRightSideBarOpen
          ? '100%'
          : 'calc(100% - 240px)'};

    margin-top: ${(props) => props.isSurveyDocOpen && props.isRightSideBarOpen && 0 + 'px'};
    margin-right: ${(props) => props.isSurveyDocOpen && props.isRightSideBarOpen && 'auto'};
    margin-bottom: ${(props) => props.isSurveyDocOpen && props.isRightSideBarOpen && 0 + 'px'};
    margin-left: ${(props) => props.isSurveyDocOpen && props.isRightSideBarOpen && 'auto'};
    margin-top: ${(props) => props.isByodDocOpen && props.isRightSideBarOpen && 0 + 'px'};
    margin-right: ${(props) => props.isByodDocOpen && props.isRightSideBarOpen && 'auto'};
    margin-bottom: ${(props) => props.isByodDocOpen && props.isRightSideBarOpen && 0 + 'px'};
    margin-left: ${(props) => props.isByodDocOpen && props.isRightSideBarOpen && 'auto'};
    margin-left: ${(props) => props.isRightSideBarOpen && 'auto'};
    margin-right: ${(props) => props.isSidebarOpen && 'auto'};
    margin-right: ${(props) => props.isSidebarOpen && props.isRightSideBarOpen && 'auto'};

    @media screen and (min-width: 1000px) and (max-width: 1300px) {
      min-height: 180vh;
    }
    @media screen and (min-width: 1500px) {
      min-height: ${(props) => (props.pathName == '/uploadPage' ? '99vh' : '180vh')};
    }
  }

  .app-store-label-div {
    display: inline-block;
    padding: 5px 0px;
    margin-left: 10px;
  }
  .app-store-label {
    font-size: 20px;
    font-weight: 700;
    line-height: 24px;
  }
  .app-store-logo-div {
    display: inline-block;
    height: 30px;
    vertical-align: middle;
  }

  .apps-unauthorized-height {
    min-height: 34vh;
  }

  .main-content {
    height: 100%;
    width: calc(100% - 9px);

    .toggleRightSideBar {
      top: 5rem;
      position: absolute;
      border: none;
      cursor: pointer;
      margin-left: 5px;
    }
    .toggle-open {
      margin-left: 1rem;
    }
    .toggle-close {
      //  margin-left:${(props) => (props.pathName === '/' ? '-2rem' : '-1rem')};
    }

    .toggleRightSideBar:after {
      content: '';
      position: absolute;
      right: -20px;
      top: 0;
      width: 0;
      height: 0;
      border-top: 50px solid transparent;
      border-bottom: 50px solid transparent;
      border-left: 20px solid #4caf50;
    }
  }

  .main-content.sidebar-closed {
    width: 100%;
    height: 100%;
  }
  .main-content.sidebar-with-survey {
    width: calc(100% - 75px);
  }
  .main-content.sidebar-with-survey.surveychatpage {
    margin-top: 18px;
  }
  .main-content.sidebar-with-survey.surveychatpage .surveyChatContainer__breadcrumbOpen {
    margin-top: 0px !important;
  }

  .loadingClass {
    display: flex;
    justify-content: center;
    position: relative;
  }
  .scrollable {
    padding-bottom: 3%;
  }

  .image-container {
    position: relative;
  }
  .sat-delivery-div {
    margin: 0% 7%;
    padding-bottom: 20px;
    height: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
  }

  @media screen and (min-width: 1396px) and (max-width: 1536px) {
    .toggle-open {
      margin-left: 1rem;
    }
    .toggle-close {
      //  margin-left:${(props) => (props.pathName === '/' ? '-2rem' : '-1rem')};
    }

    .toggleRightSideBar:after {
      content: '';
      position: absolute;
      right: -20px;
      top: 0;
      width: 0;
      height: 0;
      border-top: 50px solid transparent;
      border-bottom: 50px solid transparent;
      border-left: 20px solid #4caf50;
    }
  }

  .main-content.sidebar-closed {
    width: 100%;
    height: 100%;
  }
  .main-content.sidebar-with-survey {
    width: calc(100% - 75px);
  }
  .main-content.sidebar-with-survey.surveychatpage {
    margin-top: 18px;
  }
  .main-content.sidebar-with-survey.surveychatpage .surveyChatContainer__breadcrumbOpen {
    margin-top: 0px !important;
  }

  .loadingClass {
    display: flex;
    justify-content: center;
    position: relative;
  }
  .scrollable {
    padding-bottom: 3%;
  }

  .image-container {
    position: relative;
  }
  .sat-delivery-div {
    margin: 0% 7%;
    padding-bottom: 20px;
    height: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  @media screen and (min-width: 1396px) and (max-width: 1536px) {
    .toggle-open {
      margin-left: 1rem;
    }
    .toggle-close {
      //  margin-left:${(props) => (props.pathName === '/' ? '-2rem' : '-1rem')};
    }

    .toggleRightSideBar:after {
      content: '';
      position: absolute;
      right: -20px;
      top: 0;
      width: 0;
      height: 0;
      border-top: 50px solid transparent;
      border-bottom: 50px solid transparent;
      border-left: 20px solid #4caf50;
    }
  }

  .main-content.sidebar-closed {
    width: 100%;
    height: 100%;
  }
  .main-content.sidebar-with-survey {
    width: calc(100% - 75px);
  }
  .main-content.sidebar-with-survey.surveychatpage {
    margin-top: 18px;
  }
  .main-content.sidebar-with-survey.surveychatpage .surveyChatContainer__breadcrumbOpen {
    margin-top: 0px !important;
  }

  .loadingClass {
    display: flex;
    justify-content: center;
    position: relative;
  }
  .scrollable {
    padding-bottom: 3%;
  }

  .image-container {
    position: relative;
  }
  .sat-delivery-div {
    margin: 0% 7%;
    padding-bottom: 20px;
    height: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  @media screen and (min-width: 1396px) and (max-width: 1536px) {
    .toggle-open {
      margin-left: 1rem;
    }
    .toggle-close {
      //  margin-left:${(props) => (props.pathName === '/' ? '-2rem' : '-1rem')};
    }

    .toggleRightSideBar:after {
      content: '';
      position: absolute;
      right: -20px;
      top: 0;
      width: 0;
      height: 0;
      border-top: 50px solid transparent;
      border-bottom: 50px solid transparent;
      border-left: 20px solid #4caf50;
    }
  }

  .main-content.sidebar-closed {
    width: 100%;
    height: 100%;
  }
  .main-content.sidebar-with-survey {
    width: calc(100% - 75px);
  }
  .main-content.sidebar-with-survey.surveychatpage {
    margin-top: 18px;
  }
  .main-content.sidebar-with-survey.surveychatpage .surveyChatContainer__breadcrumbOpen {
    margin-top: 0px !important;
  }

  .loadingClass {
    display: flex;
    justify-content: center;
    position: relative;
  }
  .scrollable {
    padding-bottom: 3%;
  }

  .image-container {
    position: relative;
  }
  .sat-delivery-div {
    margin: 0% 7%;
    padding-bottom: 20px;
    height: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  @media screen and (min-width: 1396px) and (max-width: 1536px) {
    .toggle-open {
      margin-left: 1rem;
    }
    .toggle-close {
      //  margin-left:${(props) => (props.pathName === '/' ? '-2rem' : '-1rem')};
    }

    .toggleRightSideBar:after {
      content: '';
      position: absolute;
      right: -20px;
      top: 0;
      width: 0;
      height: 0;
      border-top: 50px solid transparent;
      border-bottom: 50px solid transparent;
      border-left: 20px solid #4caf50;
    }
  }

  .main-content.sidebar-closed {
    width: 100%;
    height: 100%;
  }
  .main-content.sidebar-with-survey {
    width: calc(100% - 75px);
  }
  .main-content.sidebar-with-survey.surveychatpage {
    margin-top: 18px;
  }
  .main-content.sidebar-with-survey.surveychatpage .surveyChatContainer__breadcrumbOpen {
    margin-top: 0px !important;
  }

  .loadingClass {
    display: flex;
    justify-content: center;
    position: relative;
  }
  .scrollable {
    padding-bottom: 3%;
  }

  .image-container {
    position: relative;
  }
  .sat-delivery-div {
    margin: 0% 7%;
    padding-bottom: 20px;
    height: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  @media screen and (min-width: 1396px) and (max-width: 1536px) {
    .toggle-open {
      margin-left: 1rem;
    }
    .toggle-close {
      //  margin-left:${(props) => (props.pathName === '/' ? '-2rem' : '-1rem')};
    }

    .toggleRightSideBar:after {
      content: '';
      position: absolute;
      right: -20px;
      top: 0;
      width: 0;
      height: 0;
      border-top: 50px solid transparent;
      border-bottom: 50px solid transparent;
      border-left: 20px solid #4caf50;
    }
  }

  .main-content.sidebar-closed {
    width: 100%;
    height: 100%;
  }
  .main-content.sidebar-with-survey {
    width: calc(100% - 75px);
  }
  .main-content.sidebar-with-survey.surveychatpage {
    margin-top: 18px;
  }
  .main-content.sidebar-with-survey.surveychatpage .surveyChatContainer__breadcrumbOpen {
    margin-top: 0px !important;
  }

  .loadingClass {
    display: flex;
    justify-content: center;
    position: relative;
  }
  .scrollable {
    padding-bottom: 3%;
  }

  .image-container {
    position: relative;
  }
  .sat-delivery-div {
    margin: 0% 7%;
    padding-bottom: 20px;
    height: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  @media screen and (min-width: 1396px) and (max-width: 1536px) {
    .toggle-open {
      margin-left: 1rem;
    }
    .toggle-close {
      //  margin-left:${(props) => (props.pathName === '/' ? '-2rem' : '-1rem')};
    }

    .toggleRightSideBar:after {
      content: '';
      position: absolute;
      right: -20px;
      top: 0;
      width: 0;
      height: 0;
      border-top: 50px solid transparent;
      border-bottom: 50px solid transparent;
      border-left: 20px solid #4caf50;
    }
  }

  .main-content.sidebar-closed {
    width: 100%;
    height: 100%;
  }
  .main-content.sidebar-with-survey {
    width: calc(100% - 75px);
  }
  .main-content.sidebar-with-survey.surveychatpage {
    margin-top: 18px;
  }
  .main-content.sidebar-with-survey.surveychatpage .surveyChatContainer__breadcrumbOpen {
    margin-top: 0px !important;
  }

  .loadingClass {
    display: flex;
    justify-content: center;
    position: relative;
  }
  .scrollable {
    padding-bottom: 3%;
  }
`;

export default AppStoreComponent;
